import type { ListaToolbarProps } from "./types-lista-toolbar";
import { useListaToolbar } from "./use-lista-toolbar";
import { ListaToolbarView } from "./view-lista-toolbar";

/**
 * Barra acima da Lista/Cards de Obras e do Financeiro: busca, filtros rápidos, painel de filtros, seletor
 * Lista/Cards e menu ⋮. O que muda entre as telas entra pelos slots (`quickFilters`, `actionsEnd`).
 */
export function ListaToolbar(props: ListaToolbarProps) {
  const vm = useListaToolbar(props);

  return <ListaToolbarView {...vm} />;
}

export type * from "./types-lista-toolbar";
